module.exports = __webpack_public_path__ + "img/phone.7a94b9d.svg";